import { Component } from '@angular/core';
import { AuthenticationService } from '../../../../shared/services/authentication/authentication.service';
import { TitleCasePipe } from '@angular/common';
import { DesyButtonsModule } from 'desy-angular';
import { AuthorizationsRoutes } from '../../../../shared/models/core/routes.models';

@Component({
  selector: 'app-home',
  imports: [TitleCasePipe, DesyButtonsModule],
  templateUrl: './home.component.html'
})
export class HomeComponent {
  protected readonly AuthenticationService = AuthenticationService;
  protected readonly AuthorizationsRoutes = AuthorizationsRoutes;
}
